export default {
    namespaced: true,

    state: {
        isLoading: false,
        openFilterModal: false,
    },

    getters: {
        getIsLoading(state) {
            return state.isLoading
        },

        getIsFilterModalOpen(state) {
            return state.openFilterModal
        },
    },

    mutations: {
        setIsLoading(state, isLoading) {
            state.isLoading = isLoading
        },

        setIsFilterModalOpen(state, isOpen) {
            state.openFilterModal = isOpen
        },
    },

    actions: {
        setIsLoading(Store, isLoading) {
            Store.commit('setIsLoading', isLoading)
        },

        setIsFilterModalOpen(Store, isOpen) {
            Store.commit('setIsFilterModalOpen', isOpen)
        },
    },
}
